(function () {
  'use strict';

  var HANDLE = 'personalised-rainbow-teacher-pebble-people-hanging-heart';
  var P = null;
  var submitting = false;

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clean(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }
  function money(cents) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: P.currency || 'GBP' }).format(cents / 100);
  }
  function countVal(v) { return Math.max(1, Math.min(4, parseInt(v, 10) || 1)); }

  // ── Globo suppression (CSS handles visual hide; JS disables inputs) ───────
  function hideGloboNow() {
    var found = false;
    qsa(document, '.gpo-product-variants,.gpo-container,.gpo-wrap,.gpo-form').forEach(function (node) {
      node.hidden = true;
      qsa(node, 'input,select,textarea,button').forEach(function (f) { f.disabled = true; });
      found = true;
    });
    return found;
  }

  function watchGlobo() {
    hideGloboNow();
    var observer = new MutationObserver(function () { if (hideGloboNow()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 10000);
  }

  // ── Gift box (exact dm-gift-box.liquid replica + qty conditional) ─────────
  var GB_CSS = [
    '#dm-gb-upsell-atc *{box-sizing:border-box}',
    '#dm-gb-upsell-atc{font-family:inherit;display:block;width:100%;margin:4px 0 18px}',
    '#dm-gb-upsell-atc .dm-gb-card{background:linear-gradient(148deg,#FFFAF4 0%,#FFF4E5 100%);border:1.5px solid #E8D5BC;border-radius:14px;padding:14px 16px;display:flex;gap:14px;align-items:center;position:relative;overflow:hidden}',
    '#dm-gb-upsell-atc .dm-gb-card::after{content:\'\';position:absolute;bottom:-50px;right:-30px;width:150px;height:150px;background:radial-gradient(circle,rgba(196,146,42,.07) 0%,transparent 68%);border-radius:50%;pointer-events:none}',
    '#dm-gb-upsell-atc .dm-gb-tag{position:absolute;top:10px;right:10px;background:linear-gradient(135deg,#C4922A,#D4A83A);color:#fff;font-size:9px;font-weight:800;letter-spacing:.8px;text-transform:uppercase;padding:3px 9px;border-radius:20px;margin:0}',
    '#dm-gb-upsell-atc .dm-gb-icon{flex-shrink:0;width:64px;height:64px}',
    '#dm-gb-upsell-atc .dm-gb-body{flex:1;min-width:0}',
    '#dm-gb-upsell-atc .dm-gb-eyebrow{font-size:10px;color:#C4922A;font-weight:700;letter-spacing:.7px;text-transform:uppercase;margin:0 0 3px}',
    '#dm-gb-upsell-atc .dm-gb-title{font-size:15px;font-weight:800;color:#1A1210;margin:0 0 3px;line-height:1.2}',
    '#dm-gb-upsell-atc .dm-gb-quote{font-size:12.5px;color:#8B6F5E;font-style:italic;margin:0 0 10px;line-height:1.35}',
    '#dm-gb-upsell-atc .dm-gb-qty-group{display:none;flex-wrap:wrap;gap:6px;margin:0 0 10px}',
    '#dm-gb-upsell-atc .dm-gb-qty-btn{padding:5px 14px;border:1.5px solid #D4A83A;border-radius:6px;background:#fff;font-size:12.5px;font-weight:600;cursor:pointer;font-family:inherit;color:#C4922A;transition:all .15s}',
    '#dm-gb-upsell-atc .dm-gb-qty-btn.is-active{background:#C4922A;color:#fff;border-color:#C4922A}',
    '#dm-gb-upsell-atc .dm-gb-row{display:flex;align-items:center;gap:9px;flex-wrap:wrap}',
    '#dm-gb-upsell-atc .dm-gb-price{font-size:17px;font-weight:800;color:#1A1210;flex-shrink:0}',
    '#dm-gb-upsell-atc .dm-gb-btn{flex:1;min-width:120px;background:linear-gradient(135deg,#C4922A 0%,#D4A83A 100%);color:#fff;border:none;border-radius:8px;padding:9px 12px;font-size:12.5px;font-weight:700;cursor:pointer;letter-spacing:.2px;transition:opacity .15s,transform .15s,box-shadow .15s;white-space:nowrap}',
    '#dm-gb-upsell-atc .dm-gb-btn:hover:not(:disabled){opacity:.92;transform:translateY(-1px);box-shadow:0 5px 15px rgba(196,146,42,.4)}',
    '#dm-gb-upsell-atc .dm-gb-btn:active{transform:translateY(0)}',
    '#dm-gb-upsell-atc .dm-gb-btn:disabled{cursor:default;opacity:.65}',
    '#dm-gb-upsell-atc .dm-gb-btn.dm-added{background:linear-gradient(135deg,#48895A,#5BA06C)}',
    '#dm-gb-upsell-atc .dm-gb-success{display:none;font-size:11.5px;color:#48895A;font-weight:600;margin:7px 0 0}',
    '@media(max-width:480px){#dm-gb-upsell-atc .dm-gb-card{padding:14px}#dm-gb-upsell-atc .dm-gb-icon{width:58px;height:58px}}',
    '#dm-gift-upsell{display:none !important}'
  ].join('');

  var GB_SVG = '<svg class="dm-gb-icon" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<rect x="12" y="38" width="50" height="26" rx="2.5" fill="#EDD09A"/>'
    + '<rect x="14" y="52" width="46" height="12" rx="0" fill="#D9BA7A" opacity=".4"/>'
    + '<rect x="10" y="26" width="54" height="14" rx="3" fill="#C4922A"/>'
    + '<rect x="10" y="26" width="54" height="7" rx="3" fill="#D4A83A" opacity=".55"/>'
    + '<rect x="34" y="38" width="6" height="26" fill="#A07018" opacity=".65"/>'
    + '<rect x="34" y="26" width="6" height="14" fill="#7A5200" opacity=".5"/>'
    + '<ellipse cx="29" cy="24" rx="11.5" ry="7" transform="rotate(-20 29 24)" fill="#C4922A"/>'
    + '<ellipse cx="45" cy="24" rx="11.5" ry="7" transform="rotate(20 45 24)" fill="#C4922A"/>'
    + '<ellipse cx="27" cy="22" rx="5" ry="3" transform="rotate(-20 27 22)" fill="#D8B248" opacity=".55"/>'
    + '<ellipse cx="47" cy="22" rx="5" ry="3" transform="rotate(20 47 22)" fill="#D8B248" opacity=".55"/>'
    + '<ellipse cx="37" cy="25" rx="6.5" ry="5.5" fill="#9A6600"/>'
    + '<ellipse cx="36.5" cy="24" rx="3.5" ry="2.8" fill="#C4922A" opacity=".7"/>'
    + '<rect x="18" y="47" width="20" height="1.5" rx=".75" fill="#C4922A" opacity=".28"/>'
    + '<rect x="18" y="52" width="14" height="1.5" rx=".75" fill="#C4922A" opacity=".28"/>'
    + '<rect x="18" y="57" width="17" height="1.5" rx=".75" fill="#C4922A" opacity=".28"/>'
    + '</svg>';

  function updateGiftBox(secondHeart) {
    var qtyGroup = qs(document, '#dm-gb-qty-group');
    var priceEl  = qs(document, '#dm-gb-price-display');
    if (!qtyGroup) return;
    qtyGroup.style.display = secondHeart ? 'flex' : 'none';
    if (!secondHeart) {
      qsa(document, '#dm-gb-qty-group .dm-gb-qty-btn').forEach(function (b) { b.classList.remove('is-active'); });
      var oneBtn = qs(document, '#dm-gb-qty-group [data-gb-qty="1"]');
      if (oneBtn) oneBtn.classList.add('is-active');
      if (priceEl) priceEl.textContent = money(P.giftBox);
    }
  }

  function injectGiftBox() {
    if (qs(document, '#dm-gb-upsell-atc')) return;

    if (!qs(document, '[data-dm-gb-styles]')) {
      var style = document.createElement('style');
      style.setAttribute('data-dm-gb-styles', '');
      style.textContent = GB_CSS;
      document.head.appendChild(style);
    }

    var card = document.createElement('div');
    card.id = 'dm-gb-upsell-atc';
    card.innerHTML = '<div class="dm-gb-card">'
      + '<span class="dm-gb-tag">&#10022; Add-on</span>'
      + GB_SVG
      + '<div class="dm-gb-body">'
      + '<p class="dm-gb-eyebrow">&#10022; Optional extra</p>'
      + '<h3 class="dm-gb-title">Branded Gift Box</h3>'
      + '<p class="dm-gb-quote">&ldquo;Thank you for being amazing&rdquo;</p>'
      + '<div class="dm-gb-qty-group" id="dm-gb-qty-group">'
      + '<button type="button" class="dm-gb-qty-btn is-active" data-gb-qty="1">1 box &middot; ' + money(P.giftBox) + '</button>'
      + '<button type="button" class="dm-gb-qty-btn" data-gb-qty="2">2 boxes &middot; ' + money(P.giftBox * 2) + '</button>'
      + '</div>'
      + '<div class="dm-gb-row">'
      + '<span class="dm-gb-price" id="dm-gb-price-display">' + money(P.giftBox) + '</span>'
      + '<button type="button" class="dm-gb-btn" id="dm-gb-btn-atc">+ Add Gift Box</button>'
      + '</div>'
      + '<p class="dm-gb-success" id="dm-gb-ok-atc">&#10003; Gift box added to your cart!</p>'
      + '</div></div>';

    var atcBtn = qs(document, '#product-add-to-cart');
    var target = atcBtn && (atcBtn.closest('.productView-buttons') || atcBtn.parentElement);
    if (target && target.parentElement) {
      target.parentElement.insertBefore(card, target);
    } else {
      var form = qs(document, 'form[action*="/cart/add"]');
      if (form) form.appendChild(card);
    }

    // Qty button clicks
    qsa(card, '[data-gb-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qsa(card, '[data-gb-qty]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var priceEl = qs(card, '#dm-gb-price-display');
        if (priceEl) priceEl.textContent = money(P.giftBox * parseInt(btn.dataset.gbQty, 10));
      });
    });

    // Add Gift Box button
    var addBtn = qs(document, '#dm-gb-btn-atc');
    var okEl   = qs(document, '#dm-gb-ok-atc');
    if (addBtn && !addBtn.dataset.dmBound) {
      addBtn.dataset.dmBound = '1';
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var activeQty = qs(card, '[data-gb-qty].is-active');
        var qty = activeQty ? parseInt(activeQty.dataset.gbQty, 10) : 1;
        addBtn.disabled = true;
        var orig = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: P.giftBoxVariantId, quantity: qty }] })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        }).then(function () {
          addBtn.classList.add('dm-added');
          addBtn.textContent = '✓ Added';
          if (okEl) okEl.style.display = 'block';
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = orig;
          alert('Sorry, the gift box could not be added. Please try again.');
        });
      });
    }
  }

  // ── Builder HTML ──────────────────────────────────────────────────────────
  function pebbleOpts() {
    return '<option value="">Please select</option>'
      + '<option>Adult</option><option>Teen</option><option>Child</option>'
      + '<option>Baby</option><option>Dog</option><option>Cat</option>';
  }

  function heartFieldsHtml(namePrefix, disabled) {
    var d = disabled ? ' disabled' : '';
    var pebbles = '';
    for (var i = 1; i <= 4; i++) {
      pebbles += '<label class="dm-rainbow-heart__label" data-pebble-field hidden>Pebble ' + i
        + '<select class="dm-rainbow-heart__select" name="properties[' + namePrefix + 'Pebble ' + i + ']" data-pebble' + d + '>' + pebbleOpts() + '</select></label>';
    }
    return [
      '<label class="dm-rainbow-heart__label">Wording to appear above pebble people',
        '<input class="dm-rainbow-heart__input" name="properties[' + namePrefix + 'Wording]" data-heart-wording' + d + ' placeholder="e.g. Thank you for your part in creating my story">',
      '</label>',
      '<label class="dm-rainbow-heart__label">Number of pebble people',
        '<select class="dm-rainbow-heart__select" name="properties[' + namePrefix + 'No of pebbles]" data-heart-count' + d + '>',
          '<option value="">Please select</option>',
          '<option>1</option><option>2</option><option>3</option><option>4</option>',
        '</select>',
      '</label>',
      pebbles,
      '<label class="dm-rainbow-heart__label">Names to appear below pebble people',
        '<input class="dm-rainbow-heart__input" name="properties[' + namePrefix + 'Names]" data-heart-names' + d + ' placeholder="e.g. Mrs Smith &amp; class">',
      '</label>'
    ].join('');
  }

  function createBuilder() {
    var root = document.createElement('div');
    root.className = 'dm-rainbow-heart';
    root.setAttribute('data-daisy-rainbow-heart', '');

    root.innerHTML = [
      '<p class="dm-rainbow-heart__eyebrow">Free personalisation</p>',
      '<h2 class="dm-rainbow-heart__title">Create your teacher heart</h2>',

      // Heart 1 — no heading label per user request
      '<div class="dm-rainbow-heart__heart" data-heart="one">',
        heartFieldsHtml('', false),
      '</div>',

      '<label class="dm-rainbow-heart__offer" data-second-heart-offer tabindex="0" role="checkbox" aria-checked="false">',
        '<input type="checkbox" name="properties[*SECOND HEART*]" value="YES Please" data-second-heart style="position:absolute;opacity:0;width:1px;height:1px;pointer-events:none;">',
        '<span class="dm-rainbow-heart__offer-text">Incredible offer: add a second heart</span>',
        '<strong class="dm-rainbow-heart__offer-price">+' + money(P.secondHeart) + '</strong>',
      '</label>',

      // Heart 2 — no heading label per user request
      '<div class="dm-rainbow-heart__heart" data-second-heart-wrap hidden aria-hidden="true">',
        heartFieldsHtml('(Offer) ', true),
      '</div>',

      '<p class="dm-rainbow-heart__total">Total <strong data-rainbow-heart-total>' + money(P.base) + '</strong></p>',
      '<p class="dm-rainbow-heart__error" data-rainbow-heart-error role="alert"></p>'
    ].join('');

    return root;
  }

  // ── State / update ────────────────────────────────────────────────────────
  function readHeart(section) {
    if (!section) return { wording: '', count: '', pebbles: [], names: '' };
    return {
      wording: (qs(section, '[data-heart-wording]') || {}).value || '',
      count:   (qs(section, '[data-heart-count]')   || {}).value || '',
      pebbles: qsa(section, '[data-pebble]').map(function (f) { return f.value; }),
      names:   (qs(section, '[data-heart-names]')   || {}).value || ''
    };
  }

  function getState(root) {
    return {
      heartOne:    readHeart(qs(root, '[data-heart="one"]')),
      secondHeart: !!(qs(root, '[data-second-heart]') || {}).checked,
      heartTwo:    readHeart(qs(root, '[data-second-heart-wrap]'))
    };
  }

  function updatePebbles(section, enabled) {
    var cnt = parseInt((qs(section, '[data-heart-count]') || {}).value, 10) || 0;
    qsa(section, '[data-pebble-field]').forEach(function (lbl, idx) {
      var sel = qs(lbl, '[data-pebble]');
      var visible = enabled && idx < cnt;
      lbl.hidden = !visible;
      if (sel) sel.disabled = !visible;
    });
  }

  function updateUI(root) {
    var cur = getState(root);
    var secondWrap = qs(root, '[data-second-heart-wrap]');
    var offerLbl   = qs(root, '[data-second-heart-offer]');

    secondWrap.hidden = !cur.secondHeart;
    secondWrap.setAttribute('aria-hidden', cur.secondHeart ? 'false' : 'true');
    qsa(secondWrap, 'input,select').forEach(function (f) { f.disabled = !cur.secondHeart; });
    if (offerLbl) offerLbl.setAttribute('aria-checked', cur.secondHeart ? 'true' : 'false');

    updatePebbles(qs(root, '[data-heart="one"]'), true);
    updatePebbles(secondWrap, cur.secondHeart);

    var total = P.base + (cur.secondHeart ? P.secondHeart : 0);
    qs(root, '[data-rainbow-heart-total]').textContent = money(total);

    // Sync gift box qty options with second heart state
    updateGiftBox(cur.secondHeart);
  }

  // ── Cart submission ───────────────────────────────────────────────────────
  function propertiesForHeart(heart, prefix) {
    var cnt = countVal(heart.count);
    var props = {};
    props[prefix + 'Wording']       = clean(heart.wording);
    props[prefix + 'No of pebbles'] = String(cnt);
    for (var i = 0; i < cnt; i++) {
      props[prefix + 'Pebble ' + (i + 1)] = clean((heart.pebbles || [])[i]);
    }
    props[prefix + 'Names'] = clean(heart.names);
    return props;
  }

  function buildItems(cur) {
    var bundleId = 'rainbow-heart-' + Date.now();
    var heartProps = propertiesForHeart(cur.heartOne, '');
    heartProps['*SECOND HEART*'] = cur.secondHeart ? 'YES Please (+£10.95 GBP)' : 'NO Thanks';
    heartProps['_Bundle ID'] = bundleId;
    heartProps['_Custom option flow'] = 'Daisy native rainbow heart options';

    var items = [{ id: P.mainVariantId, quantity: 1, properties: heartProps }];

    if (cur.secondHeart) {
      var offerProps = propertiesForHeart(cur.heartTwo, '(Offer) ');
      offerProps['_Bundle ID'] = bundleId;
      offerProps['_Linked product'] = 'Personalised Rainbow Teacher Pebble People Hanging Heart Gift';
      items.push({ id: P.secondVariantId, quantity: 1, properties: offerProps });
    }

    return items;
  }

  function validate(cur) {
    if (!clean(cur.heartOne.wording) || !cur.heartOne.count || !clean(cur.heartOne.names)) {
      return 'Please complete all Heart 1 fields.';
    }
    if (cur.secondHeart && (!clean(cur.heartTwo.wording) || !cur.heartTwo.count || !clean(cur.heartTwo.names))) {
      return 'Please complete all Heart 2 fields.';
    }
    return '';
  }

  function submit(root) {
    if (submitting) return;
    var cur = getState(root);
    var errEl = qs(root, '[data-rainbow-heart-error]');
    var err = validate(cur);
    if (err) { errEl.textContent = err; return; }
    errEl.textContent = '';
    submitting = true;

    var btn = qs(document, '#product-add-to-cart') || qs(document, 'form[action*="/cart/add"] button[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: buildItems(cur) })
    }).then(function (r) {
      if (!r.ok) throw new Error('Sorry, we could not add your gift to basket.');
      return r.json();
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function (e) {
      submitting = false;
      if (btn) { btn.disabled = false; btn.textContent = original; }
      errEl.textContent = e.message;
    });
  }

  // ── Injection + binding ───────────────────────────────────────────────────
  function injectBuilder(root) {
    var form = qs(document, 'product-form form[data-type="add-to-cart-form"]')
            || qs(document, 'form[action*="/cart/add"]');
    if (!form) return false;

    var globoMount = qs(document, '.gpo-product-variants') || qs(document, '.gpo-container');
    if (globoMount) {
      globoMount.parentNode.insertBefore(root, globoMount);
    } else {
      form.insertBefore(root, form.firstChild);
    }
    return true;
  }

  function bindEvents(root) {
    root.addEventListener('change', function () { updateUI(root); });

    var form = qs(document, 'product-form form[data-type="add-to-cart-form"]')
            || qs(document, 'form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); submit(root); }, true);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('#product-add-to-cart')) { e.preventDefault(); e.stopImmediatePropagation(); submit(root); }
    }, true);
  }

  function init() {
    if (window.location.pathname.indexOf('/products/' + HANDLE) === -1) return;
    P = window.DAISY_RH_PRICES;
    if (!P) return;
    if (qs(document, '[data-daisy-rainbow-heart]')) return;

    watchGlobo();

    var root = createBuilder();
    if (injectBuilder(root)) {
      bindEvents(root);
      updateUI(root);
      injectGiftBox();
      return;
    }

    [400, 900, 1800].forEach(function (d) {
      window.setTimeout(function () {
        if (qs(document, '[data-daisy-rainbow-heart]')) return;
        if (injectBuilder(root)) { bindEvents(root); updateUI(root); injectGiftBox(); }
      }, d);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
